import { useUI } from "providers/UIProvider"
import useBookingSettings from "hooks/useBookingSettings"

import { Box, Center } from "@chakra-ui/react"
import { useLocation } from "react-router-dom"
import Input from "components/UI/atoms/Input"
import Button from "components/UI/atoms/Button"
import Icon from "components/UI/atoms/Icon"
import { useSettings } from "providers/SettingsProvider/SettingsProvider"
import { useAppContext } from "providers/AppProvider/AppProvider"

const BookingSettingsForm = () => {
  const { T } = useUI()
  const { changeLaundryScheduleIntervalLoading } = useSettings()
  const { form: { values, handleChange, errors, handleSubmit, touched } } = useBookingSettings()
  const { selectedBranches } = useAppContext()
  const { pathname } = useLocation()


  return (
    <Box mt="114px" mb="154px">
      <form>
        <Box>
          <Input
            id="booking-settings-interval"
            label={T("booking_settings.form.interval_label")}
            name="interval"
            placeholder={values.placeholderInterval}
            value={values.interval}
            onChange={handleChange}
            type="number"
            error={Boolean(errors.interval && touched.interval)}
            errorMessage={errors.interval}
          />
        </Box>
        <Center as="footer" mt="85px">
          <Button
            text={T("actions.confirm")}
            onClick={handleSubmit}
            variant="success"
            styles={{
              width: "280px",
              height: "80px",
              fontSize: "xxl"
            }}
            leftIcon={
              <Icon
                name="confirm"
                iconStyles={{ width: "30px", height: "30px" }}
              />
            }
            _hover={{ backgroundColor: "#08BA36" }}
            isLoading={changeLaundryScheduleIntervalLoading}
            isDisabled={changeLaundryScheduleIntervalLoading || (selectedBranches.length === 0 && pathname === "/settings/bookings")}
          />
        </Center>
      </form>
    </Box>
  )
}

export default BookingSettingsForm